import {NextURL} from 'next/dist/server/web/next-url'
import {NextResponse} from 'next/server'

import getTenantPath from '../getTenantPath'

export const getOrderIdFromTrackUrl = (pathname: string) => {
  const match = pathname.match(/^\/track(v2)?\/([^/\?]+)\/?/)
  return match && match[2]
}

export const getVersionFromTrackUrl = (pathname: string) => {
  const match = pathname.match(/^\/track(v2)?\/([^/\?]+)\/?/)
  return match && match[1] ? match[1] : ''
}

export const rewriteTrack = (
  url: NextURL,
  pathname: string,
  viewport: 'mobile' | 'desktop',
  hostname: string
) => {
  const orderId = getOrderIdFromTrackUrl(pathname)

  if (orderId) {
    url.searchParams.set('orderId', orderId)
    url.pathname = `${getTenantPath(viewport, hostname)}/track${getVersionFromTrackUrl(pathname)}`
    return NextResponse.rewrite(url)
  }

  return null
}
